import React from 'react';
import { MessageDescriptor } from 'react-intl';
import { StreamingOverviewResponse } from 'fym-shared/src/music24/streaming';
import { TypedMemo } from '../../../common/types';
import { SMLUpgradeFeature } from '../../config/music24PlanCapabilities';
import { PeriodSectionKey, periodSectionGate, periodSectionGivenBy } from '../periodSections';
import { streamingPeriodMessages as messages } from '../streamingPeriodMessages';
import { StreamingPlanLockCard } from '../parts/StreamingPlanLockCard';
import { SectionEmptyState } from './SectionEmptyState';

interface PeriodSectionGateViewProps {
  overview: StreamingOverviewResponse;
  section: PeriodSectionKey;
  emptyTitle: MessageDescriptor;
  emptyText: MessageDescriptor;
  onOpenCatalog: () => void;
  /** The section itself. It mounts (and reads) only when the gate is open. */
  children: React.ReactNode;
}

/**
 * What a section for period numbers shows before its read: the plan card on Free (design
 * streaming-sections e4, owner decision O3), the empty state when no connected source gives the
 * data (e2), else the section.
 */
const PeriodSectionGateViewComponent: React.FC<PeriodSectionGateViewProps> = ({
  overview,
  section,
  emptyTitle,
  emptyText,
  onOpenCatalog,
  children,
}) => {
  const gate = periodSectionGate(overview, section);
  if (gate === 'locked') {
    return (
      <StreamingPlanLockCard
        feature={SMLUpgradeFeature.streamingSplit}
        title={messages.planTitle}
        testId={`streaming-${section}-plan-lock`}
      />
    );
  }
  if (gate === 'noSource') {
    return (
      <SectionEmptyState
        title={emptyTitle}
        text={emptyText}
        givenBy={periodSectionGivenBy(overview, section)}
        testId={`streaming-${section}-empty`}
        onOpenCatalog={onOpenCatalog}
      />
    );
  }
  return <>{children}</>;
};

export const PeriodSectionGateView = TypedMemo(PeriodSectionGateViewComponent);
